import { PhoneBox } from '@apply/components';
import { useCustomPaymentPhone } from '../../../fields/CustomPaymentFields';
import { isMobileScreen } from '@apply/ui';

interface PhoneNumberProps {
    customPaymentId: string;
    required?: boolean;
}

export const PhoneNumber: React.FC<PhoneNumberProps> = ({ customPaymentId, required = false }) => {
    const mobileScreen = isMobileScreen();
    const label = 'Phone Number';
    const [phone, set_phone] = useCustomPaymentPhone(customPaymentId);

    return (
        <>
            <PhoneBox
                id='customPaymentPhone'
                value={phone}
                onChange={(value) => set_phone(value)}
                label={label}
                required={required}
                width={mobileScreen ? '100%' : '200px'}
            />
        </>
    );
};
